// components/ErrorFallback.tsx
import React from 'react';
import { Button, Typography } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { ErrorFallbackProps } from '../types/wallet';

const { Title, Text } = Typography;

const ErrorContainer = styled.div`
  padding: 24px;
  text-align: center;
  background: #fff1f0;
  border-radius: 8px;
  margin: 16px 0;
`;

export const ErrorFallback: React.FC<ErrorFallbackProps> = ({ error, resetErrorBoundary }) => (
  <ErrorContainer>
    <Title level={4}>Something went wrong</Title>
    <Text type="danger">{error.message}</Text>
    <Button 
      icon={<ReloadOutlined />} 
      onClick={resetErrorBoundary}
      style={{ marginTop: 16 }}
    >
      Try again
    </Button>
  </ErrorContainer>
);

export default ErrorFallback;